import { getRobot } from './robots'

// ---------- utils ----------
const n = (x) => (Number.isFinite(x) ? x : 0)
const sumDelays = (d = {}) =>
  n(d.approach) + n(d.settle) + n(d.gripperOpen) + n(d.gripperClose) + n(d.vision) + n(d.io) + n(d.custom)

// ---------- detailed (canonical) ----------
export function calcCycleTimeDetailed({
  robotId,
  distance,                 // mm
  payload,                  // kg
  profile = 'auto',         // 'auto' | 'trapezoidal' | 'triangular'
  userSpeed,                // optional mm/s
  userAccel,                // optional mm/s^2
  delays = {},              // seconds
  sCurveApprox = false,
  sCurvePenalty = 0.06,
}) {
  const robot = getRobot(robotId)

  // effective limits (derating + floors)
  const [speedScale, accelScale] = robot.derate(payload)
  const baseSpeed = n(userSpeed) > 0 ? userSpeed : robot.ratedSpeed
  const baseAccel = n(userAccel) > 0 ? userAccel : robot.ratedAccel
  const v = Math.max(robot.minSpeed || 1, baseSpeed * speedScale)
  const a = Math.max(robot.minAccel || 1, baseAccel * accelScale)

  const D = Math.max(0, n(distance))
  const overhead = sumDelays(delays)

  if (D <= 0) {
    return { profile: 'none', v, a, Dcrit: 0, tMotion: 0, overhead, total: overhead }
  }

  // profile selection
  const Dcrit = (v * v) / a
  const trapEligible = D >= Dcrit
  const wantTrap =
    profile === 'trapezoidal' ? trapEligible :
    profile === 'triangular'  ? false       :
    /* auto */                   trapEligible

  let tMotion, chosen
  if (wantTrap) {
    const tAcc = v / a
    const dAcc = 0.5 * a * tAcc * tAcc        // v^2/(2a)
    const dCruise = Math.max(0, D - 2 * dAcc)
    const tCruise = dCruise / v
    tMotion = 2 * tAcc + tCruise
    chosen = 'trapezoidal'
  } else {
    tMotion = 2 * Math.sqrt(D / a)
    chosen = 'triangular'
  }

  if (sCurveApprox) {
    const pen = Number.isFinite(sCurvePenalty) ? Math.max(0, sCurvePenalty) : 0.06
    tMotion *= 1 + pen
  }

  const total = tMotion + overhead
  return { profile: chosen, v, a, Dcrit, tMotion, overhead, total }
}

// ---------- thin wrapper (keeps old API) ----------
export function calcCycleTime(args) {
  return calcCycleTimeDetailed(args).total
}

// ---------- pick & place sum ----------
export function calcPickPlaceCycle(robotId, pickLeg, placeLeg) {
  const t1 = calcCycleTime({ robotId, profile: 'auto', ...pickLeg })
  const t2 = calcCycleTime({ robotId, profile: 'auto', ...placeLeg })
  return t1 + t2
}
